import React, { useEffect, useRef, useState } from "react";
import { MapModal } from "../map-modal";
import { useStore } from "../../../helpers/helpers";
import { LoadingState } from "../../../components";
import { observer } from "mobx-react-lite";

interface BoothMapViewProps {
    geoJsonUrl: string;
    task: any;
}

const BoothMapView = observer(({ geoJsonUrl, task }: BoothMapViewProps) => {
    const { taskManagerStore } = useStore();
    const show_booth_map = taskManagerStore.show_booth_map;
    const geoJson = useRef(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        geoJson.current = null;
        load_booth_geo_json(geoJsonUrl);
    }, [geoJsonUrl]);
    const hasValidGeoJson =
        geoJson.current &&
        (geoJson.current.type === "FeatureCollection" ||
            geoJson.current.type === "Feature" ||
            geoJson.current.type === "Polygon" ||
            geoJson.current.type === "MultiPolygon" ||
            geoJson.current.type === "Point" ||
            geoJson.current.geometry);
    const load_booth_geo_json = async (url) => {
        setLoading(true);
        try {
            // console.log(url, "url here")
            if (geoJson.current === null && url !== "") {
                const response = await fetch(url);
                const gj = await response.json();

                geoJson.current = gj;
                console.log(geoJson.current, " response here");
            }
        } catch (e) {
            console.log(e);
        }
        console.log(hasValidGeoJson, "geo JSON current");
        setLoading(false);
    };
    if (!show_booth_map) {
        // console.log("show booth map", show_booth_map);
        // console.log("geo json url", geoJsonUrl);
        return null;
    }

    const fallbackGeoJson = {
        type: "FeatureCollection",
        features: [
            {
                type: "Feature",
                properties: { name: "center of india" },
                geometry: {
                    type: "Point",
                    coordinates: [78.6569, 22.9734],
                },
            },
        ],
    };

    const finalGeoJson = hasValidGeoJson ? geoJson.current : fallbackGeoJson;

    // console.log("geo json here", geoJson.current)
    if (loading) {
        return <LoadingState />;
    }
    return (
        <div className="z-999">
            <MapModal
                show={true}
                geojson={finalGeoJson}
                data={task}
                onClose={async () => {
                    await taskManagerStore.update_show_booth_map(false);
                }}
            />
        </div>
    );
});

export default React.memo(BoothMapView);
